module.exports = __webpack_public_path__ + "static/media/front_end_experience.1b0e6fde.png";